export const FILTERS_PAGE = 'filters';
export const SEM_FILTERS_PAGE = 'bp_filters';
export const RESULTS_PAGE = 'results';
export const TRIP_SUMMARY_PAGE = 'trip_summary';
export const DRAWER_PRIME = 'drawer_prime';
export const SEM_RESULTS_PAGE = 'bp_results';
export const SEM_TRIP_SUMMARY_PAGE = 'bp_trip_summary';
